import React, { useEffect, useState } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";

import AdditionalQuestionBar from "./AdditionalQuestionBar";
import AdditionalQuestionPrompt from "./AdditionalQuestionPrompt";
import { connect, useDispatch } from "react-redux";
import { createAction } from "utils";
import CustomTitleWithSwitch from "components/base/CustomTitleWithSwitch";
import ErrorFieldMessage, { hasError } from "components/base/ErrorFieldMessage";

const mapPropsToState = (state) => ({
  customerProfileFields: state.customerList.customerProfileFields,
  customerAdditionalDataFields: state.customerList.additionalDataFieldValues,
});
const OtherInfomationiInput = ({
  customerProfileFields,
  customerAdditionalDataFields
}) => {
  const [showPrompt, setShowPrompt] = useState(false);
  const dispatch = useDispatch();

  const additionalQuestionFieldName = "additionalQuestion";
  const customerProfileFieldsFieldName = "showCustomerProfileFields";
  const customerAdditionalFieldsFieldName = "showCustomerAdditionalFields";
  const fillOtherInfomationFieldName = "fillOtherInfomation";
  const { 
    formState: { errors },
    control,
    watch,
    setValue
  } = useFormContext();
  const { fields: additionalQuestions, append, remove, update } = useFieldArray({
    control,
    name: additionalQuestionFieldName,
  });

  const watchCustomerProfileFields = watch(customerProfileFieldsFieldName) || [];
  const watchCustomerAdditionalFields = watch(customerAdditionalFieldsFieldName) || [];

  useEffect(() => {
    dispatch(createAction("customerList/getAllCustomerProfileFields")())
    dispatch(createAction("customerList/getPagedCustomerAdditionalDataFields")({ pageSize: 100 }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const convertString = (stringData) => {
    if (!stringData) {
      return "-"
    }
    return stringData.split("_").map((word, index) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(' ');
  }
  return (
    <>
      {watch(fillOtherInfomationFieldName) && <>
        <div style={{ borderTop: "1px #C2C2C2 solid", marginTop: "30px" }} />
        {customerProfileFields?.map(field => (
          <CustomTitleWithSwitch
            title={`Show ${field?.fieldName === "REFERRAL_CODE" ? "Referral / Promotion Code" : convertString(field?.fieldName)}`}
            defaultValue={!!watchCustomerProfileFields?.find(item => item?.pk === field?.pk)}
            setValue={(value) => {
              if (value) {
                setValue(customerProfileFieldsFieldName, [...watchCustomerProfileFields, field], { shouldDirty: true });
                return
              }
              setValue(customerProfileFieldsFieldName, watchCustomerProfileFields?.filter(item => item?.pk !== field?.pk), { shouldDirty: true });
            }}
          />
        ))}
        {customerAdditionalDataFields?.map(field => (
          <CustomTitleWithSwitch
            title={`Show ${field?.fieldName || '-'}`}
            defaultValue={!!watchCustomerAdditionalFields?.find(item => item?.pk === field?.pk)}
            setValue={(value) => {
              if (value) {
                setValue(customerAdditionalFieldsFieldName, [...watchCustomerAdditionalFields, field], { shouldDirty: true });
                return
              }
              setValue(customerAdditionalFieldsFieldName, watchCustomerAdditionalFields?.filter(item => item?.pk !== field?.pk), { shouldDirty: true });
            }}
          />
        ))}
        {additionalQuestions?.map((item, index) => (
          <>
            <AdditionalQuestionBar
              data={item}
              onRemove={() => {
                remove(index)
              }}
              onEdit={(value) => {
                update(index, { ...item, ...value })
              }}
            />
            <ErrorFieldMessage
              id={`ticketCampaignAdditionalQuestion.${index}.fieldName`}
              error={hasError(errors, `ticketCampaignAdditionalQuestion.${index}.fieldName`)}
              message={hasError(errors, `ticketCampaignAdditionalQuestion.${index}.fieldName`)}
            />
          </>
        )
        )}
        <button
          className="btn-back-button-common content-add-button"
          type="button"
          onClick={() => {
            setShowPrompt(true)
          }}>
          {"Add additional question"}
        </button>
        <AdditionalQuestionPrompt
          show={showPrompt}
          setShow={setShowPrompt}
          onComfirm={(value) => {
            append(value)
          }}
        />
      </>}
    </>
  )
}

export default connect(mapPropsToState)(OtherInfomationiInput);
